import { Font, StyleSheet } from '@react-pdf/renderer';
Font.registerHyphenationCallback(word => {
  return [word];
});

Font.register({
  family: 'FontAwesome',
  src: '/fa-solid-900.ttf',
});

Font.register({
  family: 'Lato',
  fonts: [
    { src: '/Lato-Thin.ttf', fontWeight: 100 },
    { src: '/Lato-Light.ttf', fontWeight: 300 },
    { src: '/Lato-Regular.ttf', fontWeight: 400 },
    { src: '/Lato-Bold.ttf', fontWeight: 700 },
    { src: '/Lato-Black.ttf', fontWeight: 900 },
    { src: '/Lato-ThinItalic.ttf', fontWeight: 100, fontStyle: 'italic' },
    {
      src: '/Lato-LightItalic.ttf',
      fontWeight: 300,
      fontStyle: 'italic',
    },
    {
      src: '/Lato-RegularItalic.ttf',
      fontWeight: 400,
      fontStyle: 'italic',
    },
    { src: '/Lato-BoldItalic.ttf', fontWeight: 700, fontStyle: 'italic' },
    {
      src: '/Lato-BlackItalic.ttf',
      fontWeight: 900,
      fontStyle: 'italic',
    },
  ],
});

export const styles = StyleSheet.create({
  footer: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,

    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',

    backgroundColor: '#EEEEEE',

    paddingTop: 12.5,
    paddingBottom: 12.5,
    paddingHorizontal: 40,
    height: 40,
    width: '100%',
  },
  pageNr: {
    fontFamily: 'Lato',
    fontSize: 8,
  },
  eventWebsite: {
    fontSize: 10,
    fontFamily: 'Lato',
    fontWeight: 'bold',
    lineHeight: 0.8,
  },
  eventName: {
    fontFamily: 'Lato',
    fontSize: 9,
    fontWeight: 400,
  },
  headerTitle: {
    paddingRight: 35,
    paddingLeft: 35,
    paddingTop: 10,
    paddingBottom: 10,
    fontSize: 12,
    color: 'white',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    fontFamily: 'Lato',
  },
  line: {
    position: 'absolute',
    left: 0,
    top: '35%',
    width: '100%',
  },
  logo: {
    width: 95,
    height: 15,
    objectFit: 'contain',
    zIndex: 4,
  },

  section: {
    margin: 10,
    padding: 10,
    flexGrow: 1,
  },
  text: {
    fontSize: 12,
  },
  h1: {
    fontSize: 24,
    marginBottom: 10,
  },
  p: {
    marginBottom: 10,
  },
  strong: {
    fontWeight: 'bold',
  },
  em: {
    fontStyle: 'italic',
  },
  a: {
    color: 'blue',
    textDecoration: 'underline',
  },
  pageBackground: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: '100vw',
    height: '99.99vh',
    zIndex: -1,
  },
  textWrapper: {
    position: 'absolute',
    bottom: 200,
    left: 55,
    right: 0,
    border: '3px solid white',
    paddingHorizontal: 10,
    paddingTop: 12,
    paddingBottom: 46,
    minHeight: 200,
    width: 220,
  },
  centerTextWrapper: {
    position: 'absolute',
    bottom: 200,
    left: 55,
    right: 0,
    border: '3px solid white',
    paddingHorizontal: 10,
    minHeight: 200,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 220,
  },
  testimonialText: {
    fontSize: 18,
    fontFamily: 'Lato',
    fontWeight: 'bold',
    color: 'white',
  },
  companyText: {
    fontSize: 14,
    fontFamily: 'Lato',
    fontWeight: 300,
    color: 'white',
  },

  headerWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',

    width: '100%',

    backgroundColor: '#ffffff',

    paddingTop: 20,
    paddingBottom: 10,
    paddingLeft: 40,
    paddingRight: 40,
  },
  eventLogo: {
    width: 90,
    height: 18,
    objectFit: 'contain',
  },
  buttonsContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
  },
  primaryButton: {
    paddingTop: 3,
    paddingBottom: 3,
    paddingHorizontal: 12,
    border: '1px solid black',
    borderRadius: 2,
    textDecoration: 'none',
  },
  primaryButtonText: {
    color: 'white',
    fontFamily: 'Lato',
    fontSize: 9,
    fontWeight: 400,
  },
  secondaryButton: {
    paddingVertical: 3,
    paddingHorizontal: 12,
    borderRadius: 2,
    border: '1px solid black',
    borderColor: 'black',
    backgroundColor: 'transparent',
    textDecoration: 'none',
  },
  secondaryButtonText: {
    color: '#27343d',
    fontSize: 9,
    fontWeight: 400,
    fontFamily: 'Lato',
  },
  heartIcon: {
    color: '#27343d',
    fontFamily: 'FontAwesome',
    fontSize: 8,
  },
});

export const globalStyles = StyleSheet.create({
  body: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: 15,
    paddingTop: 40,
  },
  title: {
    fontSize: 14,
    fontFamily: 'Lato',
    fontWeight: 'bold',
    paddingLeft: 53,
    textTransform: 'uppercase',
  },
  bigTitle: {
    fontSize: 40,
    fontFamily: 'Lato',
    fontWeight: 900,
    paddingLeft: 53,
    paddingRight: 53,
    wordBreak: 'keep-all',
    whiteSpace: 'nowrap',
    hyphenationCallback: (word: string) => [word],
  },
  mediumTitle: {
    fontFamily: 'Lato',
    fontSize: 24,
    fontWeight: 900,
    marginLeft: 53,
    marginRight: 53,
  },
  lineBar: {
    borderTop: '3px solid black',
    marginLeft: 53,
    marginTop: 10,
    width: 100,
  },
  boldText: {
    fontSize: 11,
    fontFamily: 'Lato',
    fontWeight: 900,
    paddingLeft: 53,
  },
  regularText: {
    color: '#27343d',
    fontFamily: 'Lato',
    fontSize: 11,
    fontWeight: 300,
    paddingLeft: 53,
    paddingRight: 53,
  },
  lightPointText: {
    fontSize: 9,
    fontFamily: 'Lato',
    fontWeight: 300,
    paddingLeft: 53,
  },
  lightText: {
    fontSize: 9,
    fontFamily: 'Lato',
    fontWeight: 300,
    paddingRight: 130,
  },
});
